import { getUserOrganizationsHandler } from './overrides/getUserOrganizationsHandler'

export const handlers = [
  getUserOrganizationsHandler(),
]
